"use strict";

var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
      r,
      ar = [],
      e;

  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }

  return ar;
};

var __spread = this && this.__spread || function () {
  for (var ar = [], i = 0; i < arguments.length; i++) {
    ar = ar.concat(__read(arguments[i]));
  }

  return ar;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CustoHook = void 0;

var interfaces_1 = require("../interfaces");

var components_1 = require("./components");

var texts_1 = require("./texts");

var data_1 = require("./data");

var CustoHook =
/** @class */
function () {
  function CustoHook(fn, type, isSafe, transformationFn) {
    this.$$end$$ = true;
    this.type = interfaces_1.CustoType.component; // eslint-disable-next-line @typescript-eslint/no-this-alias

    var that = this;
    this.transformationFn = transformationFn;

    this.use = function () {
      var args = [];

      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }

      var returnValue = fn.apply(void 0, __spread(args));

      if (that.transformationFn) {
        return that.transformationFn(returnValue);
      }

      return returnValue;
    };

    this.type = type;

    this.unsafelyGetOriginalFn = function () {
      return fn;
    };

    this.isSafe = isSafe;
  }

  CustoHook.createHook = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.hook, false);
  };

  CustoHook.createFn = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.hook, true);
  };

  CustoHook.createHookOfHook = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.hook, false, ensureHook);
  };

  CustoHook.createHookOfFn = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.hook, false, ensureFn);
  };

  CustoHook.createFnOfHook = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.hook, true, ensureHook);
  };

  CustoHook.createFnOfFn = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.hook, true, ensureFn);
  };

  CustoHook.createComponentHook = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.component, false, ensureComponent);
  };

  CustoHook.createComponentFn = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.component, true, ensureComponent);
  };

  CustoHook.createTextHook = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.text, false, ensureCustoText);
  };

  CustoHook.createTextFn = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.text, true, ensureCustoText);
  };

  CustoHook.createDataHook = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.data, false, ensureCustoData);
  };

  CustoHook.createDataFn = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.data, true, ensureCustoData);
  };

  CustoHook.createRawDataHook = function (fn) {
    return new CustoHook(fn, interfaces_1.CustoType.data, false);
  };

  CustoHook.prototype.getFuncVersion = function () {
    var comp = this.clone();
    comp.isSafe = true;
    return comp;
  };

  CustoHook.prototype.getHookVersion = function () {
    var comp = this.clone();
    comp.isSafe = false;
    return comp;
  };

  CustoHook.prototype.clone = function () {
    return new CustoHook(this.use, this.type, this.isSafe, this.transformationFn);
  };

  return CustoHook;
}();

exports.CustoHook = CustoHook;

function ensureCustoData(data) {
  if (data instanceof data_1.CustoData) {
    return data.data;
  }

  return data;
}

function ensureCustoText(data) {
  if (data instanceof texts_1.CustoText) {
    return data;
  }

  return texts_1.CustoText.create(data);
}

function ensureComponent(data) {
  if (data instanceof components_1.CustoComponent) {
    return data;
  }

  return components_1.CustoComponent.create(data);
}

function ensureHook(data) {
  if (data instanceof CustoHook) {
    return data;
  }

  return CustoHook.createHook(data);
}

function ensureFn(data) {
  if (data instanceof CustoHook) {
    return data;
  }

  return CustoHook.createFn(data);
}